export const EMPTY_CUBE_CAPABILITIES = Object.freeze({
  applications: true,
  users: false,
  incidents: false,
  development: false,
  maintenance: false,
  maintenanceProcesses: false,
  operationsDocuments: false,
  portal: false,
  appAdmin: false,
});

export function cubeHomeVisibility(capabilities = EMPTY_CUBE_CAPABILITIES) {
  return {
    AppList: true,
    GestUs: capabilities.users === true,
    GestInci: capabilities.incidents === true,
    PortalCube: capabilities.portal === true,
  };
}

export function cubeAreaMenu(capabilities = EMPTY_CUBE_CAPABILITIES) {
  return [
    {
      key: "applications", label: "Aplicaciones", icon: "th-large", visible: true,
      help: "Aplicaciones que tienes autorizadas.",
      actions: [{ key: "apps", label: "Aplicaciones", url: "/home/apps", visible: true }],
    },
    {
      key: "users", label: "Gestión de usuarios", icon: "users-cog", visible: capabilities.users === true,
      help: "Usuarios, accesos, grupos y catálogo de aplicaciones.",
      actions: [
        { key: "users-list", label: "Lista de usuarios", url: "/home/users/list", visible: true },
        { key: "users-audit", label: "Auditoría de accesos", url: "/home/users/audit", visible: true },
        { key: "users-groups", label: "Gestión de grupos", url: "/home/users/groups", visible: true },
        { key: "users-apps", label: "Gestión de aplicaciones", url: "/home/users/applications", visible: true },
      ],
    },
    {
      key: "incidents", label: "Gestión de incidencias", icon: "tasks", visible: capabilities.incidents === true,
      help: "Triage, seguimiento y diagnóstico de incidencias.",
      actions: [
        { key: "incidents-manage", label: "Incidencias", url: "/home/incidents/manage", visible: true },
        { key: "incidents-mine", label: "Mis incidencias", url: "/home/incidents/mine", visible: true },
        { key: "incidents-exceptions", label: "Excepciones", url: "/home/incidents/exceptions", visible: true },
        { key: "incidents-logs", label: "Registros técnicos", url: "/home/incidents/logs", visible: true },
      ],
    },
    {
      key: "development", label: "Gestión de desarrollo", icon: "code-branch", visible: capabilities.development === true,
      help: "Planificación, decisiones y documentación del desarrollo.",
      actions: [
        { key: "roadmap", label: "Roadmap", url: "/portal/roadmap", visible: true },
        { key: "decisions", label: "Decisiones", url: "/portal/decisiones", visible: true },
        { key: "docs", label: "Documentación", url: "/portal/documentos", matchPrefix: "/portal/documentos", visible: true },
      ],
    },
    {
      key: "maintenance", label: "Mantenimiento", icon: "tools", visible: capabilities.maintenance === true,
      help: "Procesos automatizados y guías para operar el sistema.",
      actions: [
        { key: "maintenance-processes", label: "Procesos programados", url: "/home/maintenance/processes", visible: capabilities.maintenanceProcesses === true },
        { key: "operations-guides", label: "Guías operativas", url: "/portal/documentos?class=OPS_INTERNAL", visible: capabilities.operationsDocuments === true },
      ],
    },
  ].map((area) => ({ ...area, actions: area.actions.filter((action) => action.visible) }))
    .filter((area) => area.visible && area.actions.length > 0);
}

export function cubePortalNavigation(capabilities = EMPTY_CUBE_CAPABILITIES) {
  return [
    { key: "incidencias", label: "Incidencias", url: "/portal/incidencias", visible: capabilities.incidents === true },
    { key: "roadmap", label: "Roadmap", url: "/portal/roadmap", visible: capabilities.development === true },
    { key: "decisiones", label: "Decisiones", url: "/portal/decisiones", visible: capabilities.development === true },
    { key: "documentos", label: "Documentos", url: "/portal/documentos", visible: capabilities.development === true || capabilities.maintenance === true },
  ];
}
